/* eslint-disable no-empty */
import { Button, Checkbox, Form, Slider } from 'antd';
import { SliderMarks } from 'antd/es/slider';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import ChevronDownIcon from 'assets/icons/chevron-down-2.svg';
import { MasterAreaResponse } from 'domain/entities/MasterEntity';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppSelector } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TYPE_FILTER, TYPE_FILTER_PARAM } from '../CU-049-01/constant';
import { AREA_CODE, AREA_ID } from '../CU-055-02';
import { Searchparams } from '../CU-055-05/models/Master';
import { DividedColumn } from './components/DividedColumn';
import { generateArrayToObject } from './helper';
import { MasterAreaState } from './models/Master';

const MARK: SliderMarks = {
    0: 0,
    10: 10,
    20: 20,
    30: 30,
    40: 40,
};

interface props {
    masterUseCase: MasterUseCaseInterface;
}

const CU05504Page = ({ masterUseCase }: props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [searchParams] = useSearchParams();
    const areaCodeParam = searchParams.get(AREA_CODE) || '';
    const [masterAreasData, setMasterAreasData] = useState<MasterAreaState[]>([]);
    const [isCheckAll, setIsCheckAll] = useState<boolean>(false);
    const [objectValueAll, setObjectValueAll] = useState<string[]>([]);
    const areaIdParam = searchParams.get(AREA_ID) || '';

    const [isExpanded, setExpanded] = useState(true);
    const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

    const isChecking = useAppSelector((state) => state.CU05504Slice.isChecking);

    useEffect(() => {
        onFormValuesChange();
    }, [isChecking]);

    useEffect(() => {
        if (AREA_CODE)
            getAllDataMasterAreasFitList({
                areaId: Number(areaCodeParam),
            });
    }, [AREA_CODE]);

    const onFormValuesChange = () => {
        const value = form.getFieldsValue();
        let isCheckAllChecked = true;
        let isId = false;
        for (const property in value) {
            if (property.includes('id')) {
                isId = true;
                if (!form.getFieldValue(property)) {
                    isCheckAllChecked = false;
                    break;
                }
            }
        }
        form.setFieldValue('all', isId && isCheckAllChecked);
    };

    const getAllDataMasterAreasFitList = async (params: { areaId: number }) => {
        try {
            dispatch(startFetching());
            const response: MasterAreaResponse = await getMasterAreaFitList(params.areaId, 1);

            const objectFormAll: string[] = [];

            if (response?.result?.data) {
                const resultData: MasterAreaState[] = response?.result?.data.map((element) => {
                    const code = `${element.code}`;
                    objectFormAll.push(code);
                    return {
                        ...element,
                        level: 1,
                        code: code + '',
                        wasRequestd: false,
                        parentCode: '',
                    };
                });
                setObjectValueAll(objectFormAll);
                setMasterAreasData(resultData);
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(completeFetching());
        }
    };

    const getMasterAreaFitList = async (areaCode: number, level: number) => {
        return await masterUseCase.getMasterAreasFitList({ areaId: areaCode, level: level });
    };

    const onIsCheckAllChange = (e?: any): void => {
        const isChecked = e.target.checked;
        setIsCheckAll(isChecked);
        if (isChecked) form.setFieldsValue(generateArrayToObject(objectValueAll, true));
        else form.resetFields();
    };

    const submit = (value: any) => {
        const chonsenItem: string[] = [];
        for (const property in value) {
            if (property.includes('id') && value[`${property}`])
                chonsenItem.push(property.replaceAll('id', ''));
        }
        let oldMin = 0;
        let oldMax = value.age ?? 40;
        if (value.age instanceof Array) {
            oldMin = value.age[0];
            oldMax = value.age[1];
        }
        const data: Searchparams = {
            [AREA_ID]: Number(areaIdParam),
            [AREA_CODE]: Number(areaCodeParam),
            [TYPE_FILTER_PARAM]: TYPE_FILTER.fromCU05504,
            oldMin: oldMin,
            oldMax: oldMax,
            listAreaCodes2: [],
            listAreaCodes3: [],
        };

        if (!value.all) {
            Object.keys(value)
                .sort()
                .filter((element) => {
                    return element.includes('id') && value[element];
                })
                .forEach((element) => {
                    const item = element.replace('id', '').split('.');
                    const level = item.length - 1;
                    const val = item[level];
                    if (level === 0) {
                        data.listAreaCodes2 = [...(data.listAreaCodes2 ?? []), val] ?? [];
                    } else if (level === 1) {
                        const listAreaCodes2 = data.listAreaCodes2 ?? [];
                        if (!listAreaCodes2.includes(item[level - 1])) {
                            data.listAreaCodes3 = [...(data.listAreaCodes3 ?? []), val] ?? [];
                        }
                    }
                });
            if (data.listAreaCodes2?.length === 0 && data.listAreaCodes3?.length === 0) {
                data.areaId = -1;
                data.areaCode = -1;
            }
        }

        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_049_01}`, {
            state: {
                dataSearch: data,
            },
        });
    };

    const getListChild = async (item: MasterAreaState) => {
        try {
            dispatch(startFetching());
            const level = item.level ?? 0;
            const response: MasterAreaResponse = await getMasterAreaFitList(
                Number(item.code),
                level + 1,
            );
            if (response?.result?.data) {
                const childCodes: any[] = [];
                const resultData: MasterAreaState[] = response?.result?.data.map((element) => {
                    const code = `${item.code}.${element.code}`;
                    childCodes.push(code);
                    return { ...element, level: level + 1, code: code + '', wasRequestd: true };
                });
                const newMasterAreasData = [...masterAreasData];
                const index = newMasterAreasData.findIndex((element) => element.id === item.id);
                const parent = newMasterAreasData[index];
                if (parent) {
                    parent.wasRequestd = true;
                    parent.children = resultData;
                    newMasterAreasData[index] = parent;
                    setMasterAreasData(newMasterAreasData);
                    const isChecked = form.getFieldValue(`id${parent.code}`);
                    form.setFieldsValue(generateArrayToObject(childCodes, isChecked));
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <section
            className="CU-055-04-container common-container"
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
        >
            <PageTitle title="市区町村を選択" />
            <section
                className="scrollable-container"
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Form form={form} style={{ width: 723, margin: 0, padding: 0 }} onFinish={submit}>
                    <section style={{ width: '100%' }}>
                        <div className="title">市区町村を選択してください</div>
                        <section
                            style={{
                                width: '100%',
                                marginTop: 16,
                            }}
                        >
                            <div
                                {...getToggleProps({
                                    onClick: () => setExpanded((prevExpanded) => !prevExpanded),
                                })}
                                style={{ borderBottom: '1px solid rgba(207, 207, 207, 0.4)' }}
                            >
                                <section
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignContent: 'center',
                                        height: 52,
                                        alignItems: 'center',
                                    }}
                                >
                                    <div
                                        onClick={(event) => {
                                            event.stopPropagation();
                                        }}
                                    >
                                        <Form.Item
                                            style={{ margin: 0, padding: 0 }}
                                            name="all"
                                            label={false}
                                            valuePropName="checked"
                                        >
                                            <Checkbox
                                                onChange={onIsCheckAllChange}
                                                className="checkbox-font-2"
                                            >
                                                すべて
                                            </Checkbox>
                                        </Form.Item>
                                    </div>

                                    <div className={`button-style center-inside`}>
                                        <img
                                            alt=""
                                            src={ChevronDownIcon}
                                            className={`cu05504-icon ${
                                                isExpanded ? 'cu05504-icon-active' : ''
                                            }`}
                                        />
                                    </div>
                                </section>
                            </div>
                            <div {...getCollapseProps()}>
                                <section
                                    style={{
                                        width: '100%',
                                        height: 'fit-content',
                                        display: 'flex',
                                    }}
                                >
                                    <div style={{ width: '50%', paddingRight: 18 }}>
                                        <DividedColumn
                                            form={form}
                                            data={masterAreasData}
                                            getListChild={getListChild}
                                            isOdd
                                            maxLevel={2}
                                        />
                                    </div>
                                    <div style={{ width: '50%', paddingLeft: 18 }}>
                                        <DividedColumn
                                            form={form}
                                            data={masterAreasData}
                                            getListChild={getListChild}
                                            maxLevel={2}
                                        />
                                    </div>
                                </section>
                            </div>
                        </section>
                    </section>
                    <section style={{ marginTop: 64 }}>
                        <div className="title">築年数を選択してください</div>
                        <div style={{ width: '100%', marginTop: 16 }}>
                            <Form.Item name="age" style={{ margin: 0, padding: 0, width: '100%' }}>
                                <Slider
                                    range
                                    min={0}
                                    max={40}
                                    marks={MARK}
                                    step={1}
                                    defaultValue={[0, 40]}
                                />
                            </Form.Item>
                        </div>
                    </section>
                    <section style={{ width: '100%', marginTop: 64 }} className="center-inside">
                        <Button
                            className="button-login-text"
                            type="primary"
                            style={{ width: 343, height: 56, letterSpacing: -1.5 }}
                            htmlType="submit"
                        >
                            検索
                        </Button>
                    </section>
                </Form>
            </section>
        </section>
    );
};

export default CU05504Page;
